module.exports = __webpack_public_path__ + "img/2.3fec2dee.png";